import { render, staticRenderFns } from "./HistoryBillList.vue?vue&type=template&id=2f029c70&scoped=true"
import script from "./HistoryBillList.vue?vue&type=script&lang=js"
export * from "./HistoryBillList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f029c70",
  null
  
)

export default component.exports